import styled from "styled-components";

export const GeneralContainer = styled.div``;
